import { Link, useNavigate } from "react-router-dom";
import Layout from "../include/layout";
import { myroutes } from "../../routes/webroute";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import $ from "jquery"

import AuteursService from "../../services/AuteursService";
import { useSelector } from "react-redux";

export default function CreateAuteurs() {

    //##########################/// METHODES ##########################///
    //navigate pour faire les redirections
    const navigate = useNavigate()
    const [validationError, setValidationError] = useState({})
    const token = useSelector(state => state.auth.token)

    //Creation des ascesseurs getters et setters pour tout le formulaire
    const [nom_auteur, setNom] = useState('')
    const [presentation, setPresentation] = useState('')
    const [nom_interlocuteur, setNomInterlocuteur] = useState('')
    const [prenoms_interlocuteur, setPrenomsInterlocuteur] = useState('')
    const [qualite, setQualite] = useState('')
    const [telephone, setTelephone] = useState('')

    ///Save form data
    const handleSubmit = async (event) => {
        event.preventDefault()
        let form = {
            nom_auteur, presentation, nom_interlocuteur, telephone, prenoms_interlocuteur, qualite
        }

        await AuteursService.store(form,token).then((response) => {
            if (response.data.erreur) {
                Swal.fire({
                    icon: "error",
                    text: response.data.erreur,
                    showConfirmButton: false,
                    timer: 2000
                })
                setValidationError(response.data.erreur)
            } else {
                //redirection sur index
                navigate(myroutes.auteurs_index)
                Swal.fire({
                    icon: "success",
                    text: response.data.message
                })
            }
        }).catch(error => {
            Swal.fire({
                icon: "error",
                text: error.message
            })
            //affichage des erreurs sur le formulaire
            setValidationError(error.message)
        });
    }


    useEffect(() => {
        $("#submenu-2").addClass("show")
    }, [])
    //##########################/// END METHODES ##########################///

    return (
        <Layout>
            <div className="app-content pt-3 p-md-3 p-lg-4 app-card app-card-stat">
                <div className="container-xl app-card-body">

                    <div className="row g-3 align-items-center justify-content-between">
                        <div className="col-auto">
                            <div className="pagetitle">
                                <h1 className="app-page-title mb-0 text-start">Gestion</h1>
                                <nav>
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to={myroutes.dashboard} >Accueil</Link></li>
                                        <li className="breadcrumb-item"><Link to={myroutes.auteurs_index} >Auteurs</Link></li>
                                        <li className="breadcrumb-item active">Nouvel auteur </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>{/*//row*/}

                    <div className="row g-3 mb-4 align-items-center justify-content-between">
                        <div className="col-auto">
                            <h1 className="app-page-title mb-0">Enregistrement </h1>
                        </div>
                    </div>{/*//row*/}

                    <div className="app-card app-card-settings shadow-lg mb-5">
                        <div className="app-card-body py-3">
                            <Row>
                                {
                                    Object.keys(validationError).length > 0 && (
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="alert alert-danger">
                                                    <ul className="mb-0">
                                                        {
                                                            <li>{validationError}</li>
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            </Row>
                            <Form className="mx-3 settings-form" style={{ textAlign: "left" }} onSubmit={handleSubmit}>

                                <Row>
                                    <Col md={4} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nom et prénom (auteur)<i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setNom(e.target.value)}
                                                value={nom_auteur}
                                                placeholder="Le nom de l'auteur"
                                                name="nom_auteur"
                                                aria-label="nom_auteur"
                                                maxLength={100}
                                                minLength={3}
                                                type="text"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nom interlocuteur <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setNomInterlocuteur(e.target.value)}
                                                value={nom_interlocuteur}
                                                placeholder="Le nom de l'interlocuteur"
                                                name="nom_interlocuteur"
                                                aria-label="nom_interlocuteur"
                                                maxLength={100}
                                                minLength={3}
                                                type="text"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Prénoms interlocuteur <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setPrenomsInterlocuteur(e.target.value)}
                                                value={prenoms_interlocuteur}
                                                placeholder="Le prénom de l'interlocuteur"
                                                name="prenoms_interlocuteur"
                                                aria-label="prenoms_interlocuteur"
                                                maxLength={100}
                                                minLength={5}
                                                type="prenoms_interlocuteur"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Téléphone <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setTelephone(e.target.value)}
                                                value={telephone}
                                                placeholder="61000001"
                                                name="telephone"
                                                aria-label="telephone"
                                                maxLength={15}
                                                minLength={8}
                                                type="number"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Qualite <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setQualite(e.target.value)}
                                                value={qualite}
                                                placeholder=""
                                                name="qualite"
                                                aria-label="qualite"
                                                maxLength={100}
                                                type="text"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>

                                </Row>
                                <Row>
                                    <Col md={12} sm={12} className="form-group" >
                                        <Form.Group className="mb-3">
                                            <Form.Label>Présentation <i className="text-danger">*</i></Form.Label>
                                            <textarea class="form-control" name="presentation" value={presentation} id="" rows="3" onChange={(e) => setPresentation(e.target.value)}></textarea>
                                        </Form.Group>
                                    </Col>

                                </Row>


                                <Button type="submit" variant="primary">Enregistrer</Button>
                            </Form>

                        </div>{/*//app-card-body*/}
                    </div>
                    {/*//app-card*/}

                </div>{/*//container-fluid*/}
            </div>{/*//app-content*/}
        </Layout>
    )
}